import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { MLTooltipComponent } from 'ml-components-platform-react';
import _ from 'lodash';

import metadata from './MLPolicyBillingPremiumFeesComponent.metadata.json5';
import messages from './MLPolicyBillingPremiumFeesComponent.messages';
import styles from './MLPolicyBillingPremiumFeesComponent.module.scss';

function MLFeeTooltipComponent(props) {
    MLFeeTooltipComponent.propTypes = {
        tooltipHeader: PropTypes.shape({}),
        tooltipContent: PropTypes.shape({}).isRequired
    };
    const { tooltipHeader, tooltipContent } = props;
    return (
        <MLTooltipComponent
            tooltipHeader={tooltipHeader}
            tooltipContent={tooltipContent}
            tooltipWrapperClassName={styles.tooltipWraper}
        />  
    );
}

const MLPolicyBillingPremiumFeesComponent = (props) => {
    const { 
        billingSummary, 
        formatAmountString 
    } = props;

    const getDefaultAmount = () => {
        return {
            chargedToDate: {amount: 0, currency: 'usd'},
            paidToDate: {amount: 0, currency: 'usd'},
            unpaidBalance: {amount: 0, currency: 'usd'}
        };
    };

    const getPremiumAndFees = () => {
        const newPremiumAndFees = _.cloneDeep(billingSummary.premiumAndFeesInfo_ML); 
        if (_.isEmpty(newPremiumAndFees)) {
            return {
                priorTermPremium: getDefaultAmount(),
                currentTermPremium: getDefaultAmount(),
                stateFees: getDefaultAmount(),
                companyFees: getDefaultAmount()
            }
        }      
        if (_.isEmpty(newPremiumAndFees.priorTermPremium)) {
            newPremiumAndFees.priorTermPremium = getDefaultAmount();
        };
        if (_.isEmpty(newPremiumAndFees.currentTermPremium)) {
            newPremiumAndFees.currentTermPremium = getDefaultAmount();
        };
        if (_.isEmpty(newPremiumAndFees.stateFees)) {
            newPremiumAndFees.stateFees = getDefaultAmount();
        };
        if (_.isEmpty(newPremiumAndFees.companyFees)) {
            newPremiumAndFees.companyFees = getDefaultAmount();
        };
        return newPremiumAndFees;
    };

    const premiumAndFees = getPremiumAndFees();

    const getTotalChargedToDate = useCallback(() => {
        return premiumAndFees.priorTermPremium.chargedToDate.amount +
            premiumAndFees.currentTermPremium.chargedToDate.amount +
            premiumAndFees.stateFees.chargedToDate.amount +
            premiumAndFees.companyFees.chargedToDate.amount;
    }, [premiumAndFees]);

    const getTotalPaidToDate = useCallback(() => {
        return premiumAndFees.priorTermPremium.paidToDate.amount +
            premiumAndFees.currentTermPremium.paidToDate.amount +
            premiumAndFees.stateFees.paidToDate.amount +
            premiumAndFees.companyFees.paidToDate.amount;
    }, [premiumAndFees]);

    const getTotalUnpaidBalance = useCallback(() => {
        return premiumAndFees.priorTermPremium.unpaidBalance.amount +
            premiumAndFees.currentTermPremium.unpaidBalance.amount +
            premiumAndFees.stateFees.unpaidBalance.amount +
            premiumAndFees.companyFees.unpaidBalance.amount;
    }, [premiumAndFees]);

    const chargedToDateSum = {amount: getTotalChargedToDate(), currency: 'usd'};
    const paidToDateSum = {amount: getTotalPaidToDate(), currency: 'usd'};
    const unpaidBalanceSum = {amount: getTotalUnpaidBalance(), currency: 'usd'};
    
    const overrideProps = {
        priorTermChargedToDate: {
            content: formatAmountString(premiumAndFees.priorTermPremium.chargedToDate)
        },
        priorTermPaidToDate: {
            content: formatAmountString(premiumAndFees.priorTermPremium.paidToDate)
        },
        priorTermUnpaidBalance: {
            content: formatAmountString(premiumAndFees.priorTermPremium.unpaidBalance)
        },
        currentTermChargedToDate: {
            content: formatAmountString(premiumAndFees.currentTermPremium.chargedToDate)
        },
        currentTermPaidToDate: {
            content: formatAmountString(premiumAndFees.currentTermPremium.paidToDate)
        },
        currentTermUnpaidBalance: {
            content: formatAmountString(premiumAndFees.currentTermPremium.unpaidBalance)
        },
        stateFeesTooltip: {
            tooltipHeader: messages.whatAreStateFees,
            tooltipContent: messages.feesChargedByState
        },
        stateFeesChargedToDate: {
            content: formatAmountString(premiumAndFees.stateFees.chargedToDate)
        },
        stateFeesPaidToDate: {
            content: formatAmountString(premiumAndFees.stateFees.paidToDate)
        },
        stateFeesUnpaidBalance: {
            content: formatAmountString(premiumAndFees.stateFees.unpaidBalance)
        },
        feesTooltip: {
            tooltipHeader: messages.whatIsIncludedUnderFees,
            tooltipContent: messages.feesChargedByCompany
        },
        feesChargedToDate: {
            content: formatAmountString(premiumAndFees.companyFees.chargedToDate)
        },
        feesPaidToDate: {
            content: formatAmountString(premiumAndFees.companyFees.paidToDate)
        },
        feesUnpaidBalance: {
            content: formatAmountString(premiumAndFees.companyFees.unpaidBalance)
        },
        chargedToDateSum: {
            content: formatAmountString(chargedToDateSum)
        },
        paidToDateSum: {
            content: formatAmountString(paidToDateSum)
        },
        unpaidBalanceSum: {
            content: formatAmountString(unpaidBalanceSum)
        }       
    }

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            MLFeeTooltipComponent
        },
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers} />
    ); 
};

MLPolicyBillingPremiumFeesComponent.propTypes = {
    billingSummary: PropTypes.shape({
        premiumAndFeesInfo_ML: PropTypes.shape({})
    }),
    formatAmountString: PropTypes.func
};

MLPolicyBillingPremiumFeesComponent.defaultProps = {
};

export default MLPolicyBillingPremiumFeesComponent;